import axios from "axios";
import router from "../router";
const ls = require("local-storage"); //

const _axios = axios.create({
  // ls.get('base_url')
  // baseURL: "http://localhost:3002/api",
  baseURL: "https://restritofn.gab.softlineangola.com/api",
  // baseURL: "https://facturacaoapi.softlineangola.com/api"
  // baseURL: 'http://169.254.158.200:3002/api' // Cital
  // baseURL: 'http://10.112.0.20:3002/api' // ****************  LOCAL - BENDIZER
  // baseURL: 'http://192.168.1.254:3002/api' // **************** Esca
  // baseURL: 'http://192.168.1.220:3002/api' // **************** COLÉGIO ALPEGA
  // baseURL: 'http://192.168.18.16:3002/api' // **************** ILHA DA VERDADE LOCAL
  // baseURL: 'http://192.168.44.10:3002/api'  // ************************** LOcal ISPA-ATLANTIDA
  // baseURL: 'http://192.168.0.9:3002/api' //  ********************* local LUENA
  // baseURL: ls.get('base_url')
  // baseURL: 'https://apifinancas.bendizer.net/api' // BENDIZER
  // baseURL: 'https://apifinancas.ilhaverdade.gereonline.com/api' // ***************** ILHA DA VERDADE
  // baseURL: 'https://apifinancas.ispatlantida.com/api' //ATLANTIDA
  // baseURL: 'https://apifinancas.ispamazozo.com/api' //ATLANTIDA *************** MAZOZO
  // baseURL: 'https://apifinancas.isppluena.com/api/' // *************************** LUENA Base Nuvem
  // baseURL: 'http://192.168.1.9:3002/api' // Teste - Local
  // baseURL-Finanças : 'http://192.168.1.9:3000/fin/api'
});
// Add a request interceptor*
_axios.interceptors.request.use(function (config) {
  try {
    const token = ls.get("token");
    const role = ls.get("role");
    const idInstituicao = ls.get("i_id");
    const anolectivo = ls.get("anolectivo");
    const idPessoa = ls.get("idPessoa");
    const nomeUsuario = ls.get("nomeUsuario");
    const pkUsuario = ls.get("pkUsuario");
    const idanolectivo = ls.get("idanolectivo");
    const fkNegocio = ls.get("fkNegocio");
    config.headers.Authorization = token
      ? `Bearer ${token} ${role} ${idInstituicao} ${anolectivo} ${idPessoa} ${nomeUsuario} ${pkUsuario} ${fkNegocio} ${idanolectivo} `
      : "";
    return config;
  } catch (error) {
    return Promise.reject(error);
  }
});

_axios.interceptors.response.use(
  (response) => {
    // Do something with response data
    return response;
  },
  (error) => {
    // Do something with response error
    // You can even test for a response code
    // and try a new request before rejecting the promise
    try {
      if (error.response.status === 403 || error.response.status === 401) {
        ls.set("fatal", "Acesso negado");
        ls.clear();
        router.push("/");
      }
    } catch (err) {
      ls.set("fatal", "" + err + " ->  " + error);
      // router.push('/')
    }

    return Promise.reject(error);
  }
);

/** */
export default _axios;
